import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
  signal,
} from '@angular/core';
import { PcLoadingService } from 'app/shared/services/loading';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'primecontrol-loading-spinner',
  imports: [],
  templateUrl: './loading-spinner.html',
  styleUrl: './loading-spinner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent implements OnInit, OnDestroy {
  host1 = location.host.split('-')[0];
  host2 = location.host.split('.')[0];

  public isLoading = signal<boolean>(false);

  private _pcLoadingService: PcLoadingService = inject(PcLoadingService);

  private _changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  ngOnInit(): void {
    this._pcLoadingService.show$.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
      this.isLoading.set(value);
      this._changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
